var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-header',{attrs:{"height":"220"}},[_c('h3',[_vm._v("运行日志")])]),_c('el-main')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }